import React, { useState, useEffect } from 'react';
import { white } from '../../Styles/Colours';
import { Button } from '../Button';
import { LoadingErrorIcon, ReloadIcon } from '../Icons';
import NoMedications from '../../Images/noMedications.svg';
import styles from './LoadingError.module.scss';

type LoadingErrorProps = {
    message?: string;
    info?: string;
};

export const LoadingError: React.FC<LoadingErrorProps> = ({ message, info }) => {
    const [isResidentListUrl, setIsResidentListUrl] = useState(false);

    useEffect(() => {
        const url = new URL(window.location.href);
        const isResidentList = url.pathname === '/residents' && !url.search && !url.hash;
        setIsResidentListUrl(isResidentList);
    }, []);

    const reload = () => {
        window.location.reload();
    };
    return (
        <div className={isResidentListUrl ? styles.residentPageContainer : styles.container}>
            {!isResidentListUrl ? <LoadingErrorIcon /> : <img src={NoMedications} alt='No Pateint found' />}
            {isResidentListUrl ? (
                <div className={styles.bodyText}>{message || 'Refine your search to get better results'}</div>
            ) : (
                <div className={styles.bodyText}>{message || "Whoop's... we've run into an error"}</div>
            )}
            {isResidentListUrl ? (
                <div className={styles.infoContainer}>
                    <div className={styles.info}>
                        {info || "We're experiencing high traffic right now. To keep things running smoothly,"}
                    </div>
                    <div className={styles.info}>
                        {info || 'please try refining your search or using more specific filters in the filter'}
                    </div>
                    <div className={styles.info}>{info || 'panel on the left. Thanks for your patience!'}</div>
                </div>
            ) : (
                <div className={styles.infoNotResident}>
                    {info || 'Please reloading the page to try fetch the data you need.'}
                </div>
            )}
            {!isResidentListUrl && (
                <Button
                    testId='error-action'
                    onClick={reload}
                    startIcon={<ReloadIcon color={white} size={'24'} noPadding />}
                >
                    Reload
                </Button>
            )}
        </div>
    );
};
